import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalHapusError extends React.Component {

    render() {
        const { saveHandler, Model, ShowModalDel, ShowModalEditErr, cancelHandler, errors } = this.props

        return (

            <div class="mb-10">

                <Modal show={ShowModalEditErr} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Hapus</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="modal-body text-center hapus">
                            <img src="assets/img/sent.png" alt="" width="50" height="46" />
                            <p> </p>
                            <p>Tidak dapat mengubah lokasi '{Model.name}'.</p>
                            <p>Lokasi tersebut masih digunakan.</p>
                        </div>
                        <span className="error">{errors["parent_still_existed"]}</span>
                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-danger" onClick={cancelHandler}>Kembali</button>
                        {/* <button class="btn btn-danger" onClick={saveHandler} >Yakin</button> */}
                        {/* <button class="btn btn-danger" onClick={saveHandler} window.location.href = ('/catalog') >Yakin</button> */}
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
